export const baseURL = "https://appadmin.zoralive.com";

